import React from 'react';
import {
    Page,
    LayoutSingleColumn,
    LayoutWrapperTopbar,
    LayoutWrapperMain,
    LayoutWrapperFooter,
    Footer,
} from '../../components';
import { TopbarContainer } from '../../containers';
import css from './LandinPageFlipAndWin.css';
import { getLpSchemaObj, facebookImages, twitterImages } from '../LandingPage/common/helpers';
import { useSelector } from 'react-redux';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import SectionHero from '../LandingPage/sectionsFlipAndWin/SectionHero/SectionHero';
import SectionMainBenefits from '../LandingPage/sectionsFlipAndWin/SectionMainBenefits/SectionMainBenefits';
import SectionFAQ from '../LandingPage/sectionsFlipAndWin/SectionFAQ/SectionFAQ';
import SectionAuth from '../LandingPage/sectionsFlipAndWin/SectionAuth/SectionAuth';
import SectionFlipAndWin from '../LandingPage/sectionsFlipAndWin/SectionFlipAndWin/SectionFlipAndWin';

const schemaTitle = 'Flip & Win | Täglich Credits und Preise gewinnen!';
const schemaDescription =
    'Hier kannst Du täglich kostenlose Credits sowie tolle Preise deiner Lieblingsmarken gewinnen! Mehr erfahren.';

export const LandinPageFlipAndWin = () => {
    const scrollingDisabled = useSelector(state => isScrollingDisabled(state));

    return (
        <Page
            scrollingDisabled={scrollingDisabled}
            contentType="website"
            description={schemaDescription}
            title={schemaTitle}
            facebookImages={facebookImages}
            twitterImages={twitterImages}
            schema={getLpSchemaObj(schemaTitle, schemaDescription)}
        >
            <LayoutSingleColumn>
                <LayoutWrapperTopbar>
                    <TopbarContainer />
                </LayoutWrapperTopbar>
                <LayoutWrapperMain
                    className={css.layout}
                    blobBackground
                    blobProps={{
                        xDistance: 20,
                        baseWidth: 760,
                    }}
                >
                    <main className={css.container}>
                        <SectionHero />
                        <SectionFlipAndWin />
                        <SectionAuth />
                        <SectionMainBenefits />
                        <SectionFAQ />
                    </main>
                </LayoutWrapperMain>
                <LayoutWrapperFooter>
                    <Footer />
                </LayoutWrapperFooter>
            </LayoutSingleColumn>
        </Page>
    );
};

export default LandinPageFlipAndWin;
